import React, { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Button, notification } from "antd";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateAmplifyActiveComponent } from "../../redux/login/loginSlice";
// INTERFACES
import { RootState } from "../../app/store";

function CustomAmplifyBackToLogin() {
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const dispatch = useDispatch();

  const launchAlert = () => {
    notification.success({
      message: <span className="generalStyles__success">Success</span>,
      description: "Password updated successfully!",
      placement: "top",
      className: `monitoring__notification__${theme}`,
    });
  };

  useEffect(() => {
    launchAlert();
  }, []);

  return (
    <div className="mt-4">
      {/** BUTTON - LOGIN */}
      <div id="custom-target" />
      <div className="generalStyles__flex loginStyles__backToLoginTopFix">
        <div>
          <Button
            onClick={() => {
              dispatch(updateAmplifyActiveComponent("sign-in"));
            }}
          >
            Back To Login
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CustomAmplifyBackToLogin;
